// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { application } from "./application"

import CouponController from './coupon_controller';
import EmailController from './email_controller';
import HelpController from './help_controller';
import PaymentController from './payment_controller';
import PricingController from './pricing_controller';
import StripeController from './stripe_controller';
import WalletController from './wallet_controller';
import PricingUpdateController from './pricing_update_controller';
import ReceiptsController from './receipts_controller';

application.register("coupon", CouponController);
application.register("email", EmailController);
application.register("help", HelpController);
application.register("payment", PaymentController);
application.register("pricing", PricingController);
application.register("stripe", StripeController);
application.register("wallet", WalletController);
application.register("pricing-update", PricingUpdateController);
application.register("receipts", ReceiptsController);
